import AcknowledgeTermsAndConditionsView from './AcknowledgeTermsAndConditionsView'
export default AcknowledgeTermsAndConditionsView
